<template>
  <div class="comment-list">
    <div class="card comment-card" v-for="comment in comments" :key="comment.id">
  <div class="card-content">
    <div class="media">
      <div class="media-content">
        <p class="title is-5">{{comment.firstName}} {{comment.lastName}}</p>
        <p class="subtitle is-6">{{formatTime(comment.timestamp)}}</p>
      </div>
    </div>

    <div class="content">
      {{comment.comment}}
    </div>
  </div>
</div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  name: "CommentList",
  data() {
    return {
      comments:null
    };
  },
   mounted() {
    this.fetchData();
  },
  watch: {
    serial: function () {
      this.fetchData();
    }
  },
  props: ["moduleId","serial"],
  methods: {
    fetchData: function() {
      const config=this.$store.getters.config;
      const url = `${process.env.VUE_APP_API_URL}comments/${this.moduleId}`;
      axios.get(url,config).then(response => {
        if (response) {
          this.comments = response.data.comments
        }
      });
    },
    formatTime:function(timestamp){
        return moment(timestamp).utcOffset("-10:00").format('MMMM D, YYYY @ h:mm a');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.comment-card{
 margin-bottom:2rem;
}
</style>